// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__L6YLg","container":"style_container__spY_a","icon":"style_icon__L136m","title":"style_title__kpc5Q","desc":"style_desc__zQNbn"};